/* eslint-disable multiline-ternary */
import React from 'react'
import { Paper, SvgIconTypeMap, Tooltip } from '@material-ui/core'
import AddCircleIcon from '@material-ui/icons/AddCircle'
import { useBudgetStyles } from './styles'
import { OverridableComponent } from '@material-ui/core/OverridableComponent'
import clsx from 'clsx'

interface IBudgetAddCard {
  title?: string | JSX.Element
  icon?: OverridableComponent<SvgIconTypeMap<unknown, 'svg'>>
  toolTip?: string
  onClick?: () => void
  style?: React.CSSProperties
  fontStyle?: React.CSSProperties
  iconStyle?: React.CSSProperties
}

const BudgetAddCard = (props: IBudgetAddCard): JSX.Element => {
  const classes = useBudgetStyles()

  return (
    <Paper
      elevation={0}
      className={clsx(classes.root, classes.selectable)}
      onClick={props.onClick}
      style={props.style}
    >
      {props.title || 'Adicionar Orçamento'}
      <Tooltip
        title={props.toolTip || 'Adicionar novo procedimento'}
        placement="top-end"
        arrow
      >
        {props.icon ? (
          <props.icon className={classes.addIcon} style={props.iconStyle} />
        ) : (
          <AddCircleIcon className={classes.addIcon} style={props.iconStyle} />
        )}
      </Tooltip>
    </Paper>
  )
}

export default BudgetAddCard
